import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FilterCloseIcon } from "../Icons/icons.component";

export const DashboardNameModal = function ({
  show,
  onConfirm,
  onCancel,
  confirmButtonText,
  cancelButtonText,
  confirmText,
  error,
  modalTitle,
  editValue,
}) {
  const [dashboardName, setDashboardName] = useState("");
  useEffect(() => {
    if (editValue) {
      const { name } = editValue;
      if (name) {
        setDashboardName(name);
      }
    }
  }, []);

  return (
    <Modal
      show={show}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      className="customModalWrap"
    >
      <Modal.Header>
        <Modal.Title>{modalTitle}</Modal.Title>
        <button className="btnModalClose" onClick={() => onCancel(false)}>
          <FilterCloseIcon />
        </button>
      </Modal.Header>
      <Modal.Body>
        <label>{confirmText}</label>
        <div className="formControlWrap">
          <input
            type="text"
            className="form-control"
            onChange={(e) => setDashboardName(e.target.value)}
            value={dashboardName}
          />
          {error ? <p className="text-danger">{error}</p> : null}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={(e) => onConfirm(e, dashboardName)}
          className="btn btnBlue"
        >
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DashboardNameModal.defaultProps = {
  show: false,
  onConfirm: () => {},
  onCancel: () => {},
  confirmButtonText: "Ok",
  confirmText: "",
  modalTitle: "Confirmation",
  cancelButtonText: "Cancel",
};
